module.exports = __webpack_public_path__ + "img/bg-menu.ae4ef398.png";